module.exports = __webpack_public_path__ + "img/mobile-phone.e047bb20.svg";